{
  "approvalRequired": [
    {
      "title": "Date last edit",
      "value": "updatedAt",
      "width": 140,
      "key": "updatedAt"
    },
    {
      "title": "",
      "value": "priority",
      "width": 40
    },
    {
      "title": "Curator",
      "value": "curator",
      "width": 50,
      "key": "curator"
    },
    {
      "title": "Record name (id)",
      "value": "recordName",
      "width": 400,
      "key": "recordName"
    },
    {
      "title": "Last editor",
      "value": "lastEditor",
      "width": 130,
      "key": "lastEditor"
    },
    {
      "title": "Processing Notes",
      "value": "processingNotes",
      "sortable": false
    },
    {
      "title": "Accept record/edit?",
      "value": "actions",
      "sortable": false,
      "width": 130
    },
    {
      "title": "Creation date & user",
      "value": "createdAt",
      "width": 140,
      "key": "createdAt"
    }
  ],
  "maintenanceRequests": [
    {
      "title": "Date",
      "value": "createdAt",
      "key": "createdAt"
    },
    {
      "title": "Record name (id)",
      "value": "recordName",
      "key": "recordName"
    },
    {
      "title": "User login",
      "value": "userNameID",
      "key": "userNameID"
    },
    {
      "title": "Processing Notes",
      "value": "processingNotes",
      "sortable": false,
      "width": 250
    },
    { "title": "Accept request?", "value": "actions", "sortable": false }
  ],
  "recordsCreatedCuratorsLastWeek": [
    {
      "title": "Record name (id)",
      "value": "recordNameID",
      "key": "recordNameID"
    },
    {
      "title": "Date created",
      "value": "createdAt",
      "key": "createdAt"
    },
    {
      "title": "Creator",
      "value": "creator",
      "key": "creator"
    }
  ],
  "recordsInCuration": [
    {
      "title": "Record name (id)",
      "value": "recordNameID",
      "key": "recordNameID"
    },
    {
      "title": "Record maintainer(s)",
      "value": "recordMaintainers",
      "key": "recordMaintainers"
    },
    {
      "title": "Under curation by",
      "value": "curator",
      "key": "curator"
    }
  ],
  "recordsWithoutDois": [
    {
      "title": "Record name (id)",
      "value": "recordNameID",
      "key": "recordNameID"
    },
    {
      "title": "Date created",
      "value": "createdAt",
      "key": "createdAt"
    },
    {
      "title": "Date last edit",
      "value": "updatedAt",
      "key": "updatedAt"
    },
    {
      "title": "Created by",
      "value": "creator",
      "key": "creator"
    },
    {
      "title": "Last edited by",
      "value": "lastEditor",
      "key": "lastEditor"
    }
  ],
  "hiddenRecords": [
    {
      "title": "Record name (id)",
      "value": "recordNameID",
      "key": "recordNameID"
    },
    {
      "title": "Date created",
      "value": "createdAt",
      "key": "createdAt"
    },
    {
      "title": "Under curation by",
      "value": "curator",
      "key": "curator"
    },
    {
      "title": "Created by",
      "value": "creator",
      "key": "creator"
    }
  ],
  "incompleteRecords": [
    {
      "title": "Record name (id)",
      "value": "recordNameID",
      "key": "recordNameID"
    },
    {
      "title": "Date created",
      "value": "createdAt",
      "key": "createdAt",
      "width": 110
    },
    {
      "title": "Missing required",
      "value": "required",
      "key": "required"
    },
    {
      "title": "Missing recommended",
      "value": "recommended",
      "key": "recommended"
    },
    {
      "title": "Missing optional",
      "value": "optional",
      "key": "optional"
    },
    {
      "title": "Delete record",
      "value": "optional",
      "sortable": false
    }
  ],
  "systemMessages": [
    {
      "title": "ID",
      "value": "id",
      "key": "id"
    },
    {
      "title": "title",
      "value": "message",
      "key": "message"
    },
    {
      "title": "Created at",
      "value": "created_at",
      "key": "created_at"
    },
    {
      "title": "Updated at",
      "value": "updated_at",
      "key": "updated_at"
    },
    {
      "title": "Delete",
      "value": "actions",
      "sortable": false,
      "width": 130
    }
  ]
}
